import { BookOpen, CheckCircle2, KeyRound, Store } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { send } from '../../components';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../contexts/AuthContext';
import { PartnerShell } from './PartnerShell';

const statusLabel = (status) => (Number(status) === 1 ? 'Active' : 'Inactive');

const PartnerDashboard = () => {
  const { user } = useAuth();
  const partner = user?.partner;
  const [merchantTotal, setMerchantTotal] = useState(null);

  useEffect(() => {
    const loadSummary = async () => {
      const res = await send('io0021', { page: 1, per_page: 1 });
      setMerchantTotal(res?.total ?? 0);
    };

    loadSummary();
  }, []);

  return (
    <PartnerShell>
      <div className="space-y-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-sm font-medium text-primary">Partner Portal</p>
            <h1 className="text-2xl font-bold text-foreground md:text-3xl">
              {partner?.name || user?.businessName || 'Partner dashboard'}
            </h1>
            <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
              View your PayLink Partner status, API identity, and merchants created by your organization.
            </p>
          </div>
          <Button asChild>
            <Link to="/partner/docs">
              <BookOpen className="mr-2 h-4 w-4" />
              API Docs
            </Link>
          </Button>
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          <div className="card-elevated rounded-lg p-5">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-md bg-success/10 text-success">
                <CheckCircle2 className="h-5 w-5" />
              </div>
              <div>
                <p className="text-xs font-medium uppercase text-muted-foreground">Status</p>
                <p className="text-lg font-semibold text-foreground">{statusLabel(partner?.status)}</p>
              </div>
            </div>
          </div>

          <div className="card-elevated rounded-lg p-5">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary/10 text-primary">
                <KeyRound className="h-5 w-5" />
              </div>
              <div className="min-w-0">
                <p className="text-xs font-medium uppercase text-muted-foreground">Client ID</p>
                <p className="truncate text-lg font-semibold text-foreground">{partner?.clientId || '-'}</p>
              </div>
            </div>
          </div>

          <div className="card-elevated rounded-lg p-5">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-md bg-warning/10 text-warning">
                <Store className="h-5 w-5" />
              </div>
              <div>
                <p className="text-xs font-medium uppercase text-muted-foreground">Merchants</p>
                <p className="text-lg font-semibold text-foreground">{merchantTotal ?? '-'}</p>
              </div>
            </div>
          </div>
        </div>

        <section className="rounded-lg border border-border bg-white p-5">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div>
              <h2 className="text-lg font-semibold text-foreground">Partner merchants</h2>
              <p className="mt-1 text-sm text-muted-foreground">
                Review merchants registered through your Partner API access.
              </p>
            </div>
            <Button variant="outline" asChild>
              <Link to="/partner/merchants">Open merchants</Link>
            </Button>
          </div>
        </section>
      </div>
    </PartnerShell>
  );
};

export default PartnerDashboard;
